// EPI Job 详情 Service Requests「Show Info」弹窗
// 由 SectionFunction/ServiceRequest.js 的 showInfo 动态挂载渲染
// 作用：按当前 Job 的 LgaId / UtilityAuthorityId 拉取
//   - Council 的 Lodgement Info（本公司私有，Admin/LgaPrivateNote/GetDetailByLga）
//   - Water Authority 的 Property Info Lodgement（Admin/UtilityAuthority/GetDetail）
// 两段富文本合并到一个 div 内用 dangerouslySetInnerHTML 渲染，里面的链接可直接点击（与 LgaInfo 一致）
// 信息体抽到 ServiceRequestAuthorityInfoContent 复用（hover Popover 也用同一份）
import React from 'react';
import AntDraggableModal from 'components/AntDraggableModal';
import { config } from 'util/config';
import ServiceRequestAuthorityInfoContent from 'routes/Business/Job/JobDetail/ServiceRequestAuthorityInfoContent';

export default class ServiceRequestAuthorityInfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,                 // 自身控制 open（关闭后调 props.onClose 卸载）
    };
  }

  close = () => {
    this.setState({ open: false });
    // 等 Modal 关闭动画走完再卸载组件
    setTimeout(() => { this.props.onClose && this.props.onClose(); }, 200);
  };

  render() {
    const { lgaId, utilityAuthorityId, lgaName, utilityAuthorityName } = this.props;

    return (
      <AntDraggableModal
        title="Authority Info"
        open={this.state.open}
        onCancel={this.close}
        width={800}
        maskClosable={config.component.Modal.maskClosable}
        footer={null}
      >
        <ServiceRequestAuthorityInfoContent
          lgaId={lgaId}
          utilityAuthorityId={utilityAuthorityId}
          lgaName={lgaName}
          utilityAuthorityName={utilityAuthorityName}
        />
      </AntDraggableModal>
    );
  }
}
